import "./header-block.scss";
import Logo from "../../assets/icons/logo.svg";

const HeaderBlock = () => {
  return (
    <header className="header">
        <a rel="noopener noreferrer" href="/">
            <img className="header__logo" src={Logo} alt="Логотип Сберегаем Вместе"/>
        </a>
    </header>
  );
};

export default HeaderBlock;
